import { useState } from "react"

export default function Navbar() {
    const [isActive, setIsActive] = useState('');

    function activeHnadler(value) {
        setIsActive(value);
    }

    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-transparent">
            <div className="container-fluid">
                <a className="navbar-brand font-weight-bold" href="/">
                   <span className="color">K</span>ashish
                    </a>
                <div className="collapse d-flex" id="navbarNav">
                    <ul className="navbar-nav font-weight-bold">
                        <li className="nav-item mr-5">
                            <a className={isActive === 'home' ? 'active nav-link' : 'nav-link'} aria-current="page" href="#home" onClick={() => activeHnadler('home')}>Home</a>
                        </li>
                        <li className="nav-item mr-5">
                            <a className={isActive === 'skills' ? 'active nav-link' : 'nav-link'} href="#skills" onClick={() => activeHnadler('skills')}>Skills</a>
                        </li>
                        <li className="nav-item mr-5">
                            <a className={isActive === 'projects' ? 'active nav-link' : 'nav-link'} href="#projects" onClick={() => activeHnadler('projects')}>Projects</a>
                        </li>
                        <li className="nav-item mr-5">
                            <a className={isActive === 'contact' ? 'active nav-link' : 'nav-link'} href="#contact" onClick={() => activeHnadler('contact')}>Contact</a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}